<template>
  <Card class="events-card">
    <template slot="title">
      Details
    </template>
    <template slot="content">
      <div v-if="selectedEvent">
        <div class="p-grid">
          <div class="p-col">
            <span><b>Timestamp :  </b>{{ selectedEvent.timestamp.value }}</span>
            <br/>
            <span><b>Request ID :  </b>{{ selectedEvent.request_id }}</span>
            <br/>
            <span><b>User :  </b>{{ selectedEvent.user }}</span>
          </div>
          <div class="p-col">
            <span><b>UID : </b>{{ selectedEvent.epc.human_readable }}</span>
            <br/>
            <span><b>Result :  </b>{{ selectedEvent.authentication_result }}</span>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
export default {
  name: "EventDetails",
  props: {
    selectedEvent: Object
  },
}
</script>

<style scoped>
.events-card {
  width: 100%;
  height: 100%;
}
</style>